import Component from '../abstracts/Component';

export default class ResetPwLogic extends Component {

  get SELECTORS() {
    return {
      resetPwLayer: '.js-reset-pw-layer',
      formContainer: '#js-reset-form-container',
      form: '.js-reset-layer-form',
      trigger: '.js-forgot-pw'
    };
  }

  constructor() {
    super();
  }

  insertFormLayer(resp) {
    $(this.SELECTORS.formContainer).html(resp);
  }

  bindEvents() {

    let ctx = this;

    $('body').on('click.showInput', this.SELECTORS.trigger, function(e) {
      e.preventDefault();
      let $elem = $(this);

      $.ajax({
        url:  $elem.attr('href'),
        data: $elem.data(),
        dataType: "html",
        success: function (resp) {
          ctx.log('Resetpw...');
          ctx.insertFormLayer(resp);
        },
        error: function (xhr) {
          ctx.log(xhr);
        }
      });
     
    })

    $('body').on('submit.resetPw', ctx.SELECTORS.form, function (e) {
      e.preventDefault();
      let $this = $(this);
      let url = $this.attr('action');

      $.ajax({
        type: "POST",
        url: url,
        data: $this.serialize(),
        success: function (html) {
          ctx.log('Thanksss for resetpw...');
          $(ctx.SELECTORS.resetPwLayer).html($(html).find('#response-resetpw'));
          if($(html).find('#response-resetpw').length == 0) {
        	  $(ctx.SELECTORS.resetPwLayer).html($(html).find('#main-recovery-form')); 
          }
        },
        error: function (html) {
          ctx.log('Resetpw submit error ');
          ctx.log($this.serialize())
        }
      });
    });
    
  }

  render() {
    this.log('Load logics...');
    this.bindEvents();
  }
}
